export const TRANSLATIONS: Record<string, Record<string, string>> = {
  en: {
    'home.headline': 'Welcome',
    'home.bio': 'Welcome to my portfolio. This space tells my professional journey in a clear and authentic way: projects, technologies, practical choices, and lessons learned on the field. It is not just a list of skills, but a place where method, consistency, and curiosity come together. To learn more about my profile or my work approach, you can talk to my virtual assistant or contact me directly on LinkedIn or via email. Enjoy browsing.',
    'home.contact': 'Contact me',
    'home.linkedin': 'LinkedIn',
    'home.speak': 'Speak to me',
    'home.writeHere': 'Write here',
    'home.suggestion.profile': 'Tell me about Alessandro in brief',
    'home.suggestion.technical': 'What are his main technical skills?',
    'home.suggestion.experience': 'What experience does he have as an Analyst Developer?',
    'home.suggestion.leadership': 'What is his leadership approach?',
    'home.suggestion.contacts': 'How can I contact him?',
    'demo.suggestion.home': 'Which policy do you recommend?',
    'demo.suggestion.car': 'What do I need based on my answers?',
    'demo.suggestion.life': 'What are the best options for me?',
    'demo.suggestion.cost': 'Which home insurance do you recommend?',
    'demo.suggestion.coverage': 'I need complete protection',
    'demo.description': 'I\'m your insurance advisor. The more you tell me about your life, the better I can assess your risks and suggest customized solutions.',
    'job.heading': 'Job Experience',
    'education.heading': 'Education',
    'skills.label': 'Skills',
    'example.title': 'Example',
    'example.action': 'Action',
    'example.other': 'Other',
    'cookie.title': 'Cookie policy',
    'auth.title': 'Demo Access',
    'auth.description': 'This is a protected page. Please enter your credentials.',
    'auth.username': 'Username',
    'auth.password': 'Password',
    'auth.login': 'Login',
    'auth.question': 'Question',
    'questionnaire.question_label': 'Question',
    'questionnaire.of': 'of',
    'questionnaire.continue': 'Continue',
    'questionnaire.greeting': 'Hello! I\'m your specialized insurance adviser. Thank you for answering our questions. How can I help you?',
    'q1.question': 'What is your main need today?',
    'q1.option1': 'Protect my family',
    'q1.option2': 'Protect my home',
    'q1.option3': 'Insure my car',
    'q1.option4': 'Reduce insurance costs',
    'q1.option5': 'Have complete coverage',
    'q2.question': 'Do you have dependents?',
    'q2.option1': 'Yes',
    'q2.option2': 'No',
    'q3.question': 'Are you a homeowner?',
    'q3.option1': 'Yes',
    'q3.option2': 'No',
    'q4.question': 'What type of vehicle usage do you have?',
    'q4.option1': 'Occasional use',
    'q4.option2': 'Daily use',
    'q4.option3': 'Frequent or long trips',
    'q5.question': 'How important is savings versus protection to you?',
    'q5.description': '1 = I want to spend as little as possible, 5 = I want maximum protection',
    'q6.question': 'Which risks concern you most?',
    'q6.option1': 'Weather events',
    'q6.option2': 'Theft',
    'q6.option3': 'Road accidents',
    'q6.option4': 'Economic emergencies',
    'q6.option5': 'Liability to third parties',
    'q7.question': 'Which policies do you already own?',
    'q7.option1': 'Casa Basic - Covera',
    'q7.option2': 'Casa Comfort Plus - Covera',
    'q7.option3': 'Casa Gold Premium - Covera',
    'q7.option4': 'Auto Essenziale - Covera',
    'q7.option5': 'Auto Protezione - Covera',
    'q7.option6': 'Auto SelfDrive Premium - Covera',
    'q7.option7': 'Furto Auto - Protezione Corpi Veicoli',
    'q7.option8': 'Collisione Auto - Protezione Sinistri Stradali',
    'q7.option9': 'Incendio Auto - Protezione da Fuoco e Scoppio',
    'q7.option10': 'Vita Capital Garantito',
    'q7.option11': 'Vita Protezione Reddito',
    'q7.option12': 'Vita Risparmio Maturato',
    'q7.option13': 'No policies',
    'q_age.question': 'What is your age?',
    'q_age.option1': '18-25 years',
    'q_age.option2': '26-35 years',
    'q_age.option3': '36-45 years',
    'q_age.option4': '46-55 years',
    'q_age.option5': 'Over 55 years',
    'q_gender.question': 'What gender do you identify as?',
    'q_gender.option1': 'Male',
    'q_gender.option2': 'Female',
    'q_gender.option3': 'Other',
    'q_gender.option4': 'Prefer not to answer',
    'q_job.question': 'What is your employment situation?',
    'q_job.option1': 'Employee',
    'q_job.option2': 'Freelancer',
    'q_job.option3': 'Entrepreneur/Self-employed',
    'q_job.option4': 'Student',
    'q_job.option5': 'Retiree',
    'q_job.option6': 'Unemployed/Job seeking',
    'q_job.option7': 'Not working'
  },
  it: {
    'home.headline': 'Benvenuto',
    'home.bio': 'Benvenuti nel mio portfolio. Questo spazio racconta in modo chiaro e autentico il mio percorso professionale: progetti, tecnologie, scelte pratiche e lezioni apprese sul campo. Non è solo un elenco di competenze, ma un luogo in cui metodo, costanza e curiosità si incontrano. Per approfondire il mio profilo o il mio approccio al lavoro, potete parlare con il mio assistente virtuale oppure contattarmi direttamente su LinkedIn o via email. Buona navigazione.',
    'home.contact': 'Contattami',
    'home.linkedin': 'LinkedIn',
    'home.speak': 'Parlami',
    'home.writeHere': 'Scrivi qui',
    'home.suggestion.profile': 'Parlami di Alessandro in breve',
    'home.suggestion.technical': 'Quali sono le sue competenze tecniche principali?',
    'home.suggestion.experience': 'Che esperienza ha come Analyst Developer?',
    'home.suggestion.leadership': 'Qual è il suo approccio alla leadership?',
    'home.suggestion.contacts': 'Come posso contattarlo?',
    'demo.suggestion.home': 'Quale polizza mi consigli?',
    'demo.suggestion.car': 'Cosa mi serve in base alle mie risposte?',
    'demo.suggestion.life': 'Quali sono le migliori opzioni per me?',
    'demo.suggestion.cost': 'Quale polizza Casa mi consigli?',
    'demo.suggestion.coverage': 'Ho bisogno di protezione completa',
    'demo.description': 'Sono il tuo consulente assicurativo. Più mi racconti della tua vita, meglio posso valutare i tuoi rischi e suggerire soluzioni personalizzate.',
    'job.heading': 'Esperienze lavorative',
    'education.heading': 'Formazione',
    'skills.label': 'Competenze',
    'example.title': 'Esempio',
    'example.action': 'Azione',
    'example.other': 'Altro',
    'cookie.title': 'Informativa cookie',
    'auth.title': 'Accesso Demo',
    'auth.description': 'Questa è una pagina protetta. Inserisci le tue credenziali.',
    'auth.username': 'Username',
    'auth.password': 'Password',
    'auth.login': 'Accedi',
    'auth.question': 'Domanda',
    'questionnaire.question_label': 'Domanda',
    'questionnaire.of': 'di',
    'questionnaire.continue': 'Continua',
    'questionnaire.greeting': 'Ciao! Sono un assistente specializzato in polizze assicurative. Grazie per aver risposto ai nostri quesiti. Come posso aiutarti?',
    'q1.question': 'Qual è la tua principale esigenza oggi?',
    'q1.option1': 'Proteggere la mia famiglia',
    'q1.option2': 'Proteggere la mia casa',
    'q1.option3': 'Assicurare la mia auto',
    'q1.option4': 'Ridurre i costi assicurativi',
    'q1.option5': 'Avere una copertura completa',
    'q2.question': 'Hai persone a carico?',
    'q2.option1': 'Sì',
    'q2.option2': 'No',
    'q3.question': 'Sei proprietario di un\'abitazione?',
    'q3.option1': 'Sì',
    'q3.option2': 'No',
    'q4.question': 'Che tipo di utilizzo fai del veicolo?',
    'q4.option1': 'Uso saltuario',
    'q4.option2': 'Uso quotidiano',
    'q4.option3': 'Viaggi frequenti o lunghi',
    'q5.question': 'Quanto è importante per te il risparmio rispetto alla protezione?',
    'q5.description': '1 = voglio spendere il meno possibile, 5 = voglio la massima protezione',
    'q6.question': 'Quali rischi ti preoccupano di più?',
    'q6.option1': 'Eventi climatici',
    'q6.option2': 'Furti',
    'q6.option3': 'Incidenti stradali',
    'q6.option4': 'Imprevisti economici',
    'q6.option5': 'Responsabilità verso terzi',
    'q7.question': 'Quali polizze possiedi già?',
    'q7.option1': 'Casa Basic - Covera',
    'q7.option2': 'Casa Comfort Plus - Covera',
    'q7.option3': 'Casa Gold Premium - Covera',
    'q7.option4': 'Auto Essenziale - Covera',
    'q7.option5': 'Auto Protezione - Covera',
    'q7.option6': 'Auto SelfDrive Premium - Covera',
    'q7.option7': 'Furto Auto - Protezione Corpi Veicoli',
    'q7.option8': 'Collisione Auto - Protezione Sinistri Stradali',
    'q7.option9': 'Incendio Auto - Protezione da Fuoco e Scoppio',
    'q7.option10': 'Vita Capital Garantito',
    'q7.option11': 'Vita Protezione Reddito',
    'q7.option12': 'Vita Risparmio Maturato',
    'q7.option13': 'Nessuna polizza',
    'q_age.question': 'Qual è la tua età?',
    'q_age.option1': '18-25 anni',
    'q_age.option2': '26-35 anni',
    'q_age.option3': '36-45 anni',
    'q_age.option4': '46-55 anni',
    'q_age.option5': 'Oltre 55 anni',
    'q_gender.question': 'Che sesso dichiari?',
    'q_gender.option1': 'Uomo',
    'q_gender.option2': 'Donna',
    'q_gender.option3': 'Altro',
    'q_gender.option4': 'Preferisco non rispondere',
    'q_job.question': 'Qual è la tua situazione lavorativa?',
    'q_job.option1': 'Dipendente',
    'q_job.option2': 'Libero professionista',
    'q_job.option3': 'Imprenditore/Autonomo',
    'q_job.option4': 'Studente',
    'q_job.option5': 'Pensionato',
    'q_job.option6': 'Disoccupato/In cerca di lavoro',
    'q_job.option7': 'Non occupato'
  }
};
